module.exports = __webpack_public_path__ + "static/media/Ver-by-VBM-2c-JPG.f64e269a.jpg";